<template lang='pug'>
  v-simple-table
    template(v-slot:default)
      thead
        tr
          th Type
          th Suites
          th Interval/Detect URL
          th Enabled
          th Sequential
          th
      tbody
        tr(v-for='(item,index) in value' :key='index')
          td
            capitalize(v-model='item.type')
          td
            chip-names(v-model='item.testSuites')
          td
            run-configuration-target(:config='item')
          td
            v-icon(v-if='item.enabled') check
          td
            v-icon(v-if='item.sequential') check
          td.text-right.pr-8
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn(v-on='on' text icon @click='edit(index)')
                  v-icon edit
              span Edit
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn(v-on='on' text icon @click='disable(index)')
                  v-icon not_interested
              span(v-if='!item.enabled') Enable
              span(v-if='item.enabled') Disable
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn.removeButton(v-on='on' text icon @click='remove(index)')
                  v-icon delete
              span Remove
</template>

<script>
import Capitalize from '@/components/Capitalize';
import ChipNames from '@/components/ChipNames';
import RunConfigurationTarget from '@/components/RunConfigurationTarget';
import Notifications from '@/services/notification.service';

export default {
  name: 'RunConfigurationsTable',
  components: {RunConfigurationTarget, ChipNames, Capitalize},
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    async remove(index) {
      const yes = await Notifications.confirm('Remove', 'Are you sure you want to remove this run configuration?');
      if (!yes) return;
      this.$emit('remove', index);
    },
    edit(index) {
      this.$emit('edit', index);
    },
    disable(index) {
      this.$emit('disable', index);
    }
  }
};
</script>

<style scoped>

</style>
